/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  container: {
    maxWidth: '1184px',
  },
  contentArea: {
    padding: '0 0 82px',
  },
  img: { maxWidth: '100%' },
  bannerArea: {
    display: 'grid',
    alignItems: 'center',
    textAlign: 'center',
    '& img': { maxWidth: '100%' },
    '& $textHolder': {
      fontSize: '12px',
      color: '#565960',
      marginBottom: '25px',

      '& h1': {
        color: '#A76708',
        fontWeight: '600',
        marginBottom: '12px',
        fontSize: '14px',
      },
      '& p': {
        fontSize: '12px',
      },
    },
    '& $textHolderApproval': {
      fontSize: '14px',
      color: '#565960',
      marginBottom: '25px',

      '& h1': {
        color: '#138266',
        fontWeight: '600',
        marginBottom: '12px',
      },
      '& p': {
        fontSize: '12px',
      },
    },
    '& $textHolderTermination': {
      fontSize: '14px',
      color: '#565960',
      marginBottom: '25px',

      '& h1': {
        color: '#D2374F',
        fontWeight: '600',
        marginBottom: '12px',
      },
    },
  },
  textHolder: {},
  textHolderApproval: {},
  textHolderTermination: {},
  textDownload: {
    color: '#342D3D',
    fontWeight: '600',
    marginBottom: '20px',
    display: 'inline-block',
    '& img': {
      marginRight: '8px',
    },
  },
  detailItem: {
    borderBottom: '1.46951px solid #EBEEF3',
    padding: '20px 0',
    color: '#565960',
    display: 'flex',
    alignItems: 'center',
    '&:first-child': {
      borderTop: '1.46951px solid #EBEEF3',
    },
    '& h2': {
      fontWeight: '600',
      color: '#342D3D',
      fontSize: '12px',
    },
    '& p': {
      fontSize: '12px',
    },
  },
  darkgray: {
    color: '#fff',
    background: '#1C999B',
  },
  uniChip: {
    fontWeight: '500',
    fontSize: '12px',
    padding: '8px 16px',
    marginLeft: 'auto',
  },
  btnADGMOutlineBlack: {
    height: 'auto',
    width: 'auto',
    padding: '15px 28px',
    minWidth: '330px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'none',
    border: '1px solid #342D3D',
    borderRadius: '10px',
    marginTop: '12px',
    '& img': {
      marginRight: '1em',
    },
  },
  applicationIdStyle: {
    textAlign: 'center',
    padding: '10px 0',
    fontSize: '12px',
  },
  gotoproBtn: {
    display: 'block',
    height: '60px',
    background: theme.palette.primary.main,
    color: '#fff',
    borderRadius: '10px',
    fontWeight: '600',
    fontSize: '16px',
    width: '100%',
    marginTop: '32px',
    textTransform: 'none',
    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
  '@media (min-width: 768px)': {
    bannerArea: {
      gridTemplateColumns: '176px auto',
      textAlign: 'left',
      gap: '17px',
      '& $textHolder': {
        fontSize: '14px',
        '& h1': {
          fontSize: '20px',
        },
        '& p': {
          fontSize: '14px',
        },
      },
    },
    detailItem: {
      '& h2': {
        fontSize: '18px',
      },
      '& p': {
        fontSize: '1rem',
      },
    },
    uniChip: {
      fontSize: '16px',
      padding: '8px 16px',
    },
    btnADGMOutlineBlack: {
      padding: '12px 20px',
      fontSize: '16px',
    },
    applicationIdStyle: {
      textAlign: 'right',
      fontSize: '16px',
    },
  },
  '@media (min-width: 992px)': {
    contentArea: {
      padding: '60px 0',
    },
  },
  '@media (max-width: 767px)': {
    textDownload: {
      display: 'block',
      width: '100%',
      border: '1px solid #342D3D',
      borderRadius: '10px',
      textAlign: 'center',
      padding: '11px 10px',
    },
    successImgHolder: {
      display: 'flex',
      justifyContent: 'center',
    },
    successImg: {
      width: '120px',
      height: '120px',
    },
    bannerArea: {
      '& $textHolder': {
        marginBottom: '0px',
        width: '80%',
        margin: '0 auto',
        '& h1': {
          marginTop: '24px',
        },
      },
    },
    mobileTitlehead: {
      borderBottom: '3px solid #EBEEF3',
      '& > div': {
        padding: '15px',
      },
      '& a': {
        color: '#342D3D',
        padding: '7px 0',
        fontWeight: '500',
        display: 'block',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'none',
        },
        '& img': {
          marginRight: '13px',
        },
      },
      '& $grayArea': {
        background: '#F8F8F8',
        color: '#8C9099',
        '& p': {
          fontSize: '12px',
        },
      },
    },
    fixedonMobileHolder: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      background: '#fff',
      padding: '16px',
      borderTop: '3px solid #EBEEF3',
      zIndex: '1021',
      '& button': {
        width: '100%',
        margin: '0',
        height: '48px',
      },
    },
  },
});

export default styles;
